import GenerateAPIKey from './GenerateAPIKey';

export default GenerateAPIKey;
